/*global translate BigInt*/
import React, { useState, useEffect } from 'react';
const { rxgetLocal } = global.rootRequire('classes/request')
const { changeColorSVG } = global.rootRequire('classes/ulti');
require('./rxCallRating.css')
const api = 'create_call_rating'

function RxCallRating({ score = 0, isOpen = false, group_id, call_id, func }) {

  const [openRatingCall, setOpenRatingCall] = useState(isOpen)
  const [ratingScore, setRatingScore] = useState(score)
  const [mouseHover, setMouseHover] = useState(0)
  const [complaint, setComplaint] = useState('')
  
  // danh gia duoi 3 sao thi cho user nhap noi dung
  let isComplaint = ratingScore <= 3 && ratingScore > 0

  const submitRating = () => {
    if (ratingScore > 0) {
      let token = global.rxu.json(rxgetLocal('rxuserneta'), { user: {} }).user.token

      let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': token }
      const textcomplaint = document.getElementById('zchat_callrating_complaint_message_value')

      fetch(global.rxu.get(global.rxu.config, api), {
        method: 'POST',
        body: `{ "group_id": ${BigInt(group_id)}, "call_id": ${BigInt(call_id)}, "score": ${ratingScore}, "comment": "${isComplaint ? (textcomplaint?.value || '') : '' }" }`,
        headers: headers }).then((res) => { return res.json() })
        .then((json) => {
          console.log('Thank you for your rating!', json)
        }).catch(er => console.log(er))
    }
    setOpenRatingCall(false);
    func(false);
  }

  return (
      openRatingCall ? 
      <div className='avatarClick_rectangle'>
        <div className='avatarClick_rectangle_1' onClick={() => {setOpenRatingCall(true); func(true);}}></div>
        <div className='zchat_callrating_reactangle_2_1'>
          <div className='avatarClick_title_place modal'>
            <div className='avatarClick_title modal'>{translate('Please rate the quality of your call')}</div>
            <div className='avatarClick_closeIcon' onClick={() => { setOpenRatingCall(false); func(false);}}>
              <img className='icon-basic-up filter_img_class' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} alt='' />
            </div>
          </div>
          <div className="zchat_callrating_rodal_body">
            <div className='zchattab_body' style={{ paddingRight: 'unset' }}>
              <div className='zchat_body mtheme zchat_callrating' id='zchat_callrating'>
                {[5,4,3,2,1].map((scoreItem, index) => {
                  return (
                    <button key={index}
                      className={((scoreItem <= ratingScore) && (ratingScore <= mouseHover)) ? 'score' : ''}
                      data-rating={scoreItem}
                      onMouseOver={() => setMouseHover(scoreItem)}
                      onMouseLeave={() => setMouseHover(ratingScore)}
                      onClick={() => setRatingScore(ratingScore === scoreItem ? 0 : scoreItem)}>
                      {/* <i className='icon-star'></i> */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" className='svg-star'>
                        <g data-name="icon-star">
                          <path data-name="Path 121984" d="M-8170.164 23853.373a1.977 1.977 0 0 1-.719-1.988l1.874-8.613-6.359-5.82a1.978 1.978 0 0 1-.541-2.047 1.857 1.857 0 0 1 1.592-1.326l8.413-.793 3.328-8.117a1.853 1.853 0 0 1 1.7-1.172 1.866 1.866 0 0 1 1.706 1.172l3.321 8.117 8.421.793a1.878 1.878 0 0 1 1.592 1.326 1.98 1.98 0 0 1-.542 2.047l-6.36 5.82 1.876 8.613a1.98 1.98 0 0 1-.72 1.988 1.811 1.811 0 0 1-1.083.363 1.8 1.8 0 0 1-.953-.273l-7.258-4.523-7.257 4.523a1.7 1.7 0 0 1-.945.285 1.757 1.757 0 0 1-1.086-.375z" transform="translate(8182.874 -23816.621)"/>
                        </g>
                      </svg>
                    </button>
                  )
                })}
              </div>
              {isComplaint ?
                <div className='zchat_callrating_complaint_message'>
                  <textarea id='zchat_callrating_complaint_message_value' type='textarea' rows="4" cols="40" placeholder={translate('Please tell us your opinion')}></textarea>
                </div>  
                : null}
            </div>
          </div>
          <div className="rodal-footer">
            <div className="zmessage_text my_message cbtn callrating_back">
              <div>
                <div className="zchat-textmess" onClick={() => {setOpenRatingCall(false); func(false);}}>{translate('Not now')}</div>
              </div>
            </div>
            <div className="zmessage_text my_message cbtn callrating_send">
              <div>
                <div className="zchat-textmess" onClick={() => { if (ratingScore != 0) { submitRating() }}}>{translate('Submit')}</div>
              </div>
            </div>
          </div>
        </div >
      </div>
      : null
  )
}

export default RxCallRating